import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Button, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import { internApi } from "@/api/intern-api";

const taskList = [
  {
    type: "tracks",
    label: "Conflicts",
    route: "tracks",
    instruction:
      "https://docs.google.com/document/d/1oY7imeKoKNV1L5VSOyKZgMBZ-MlJwE9JmwM1z80DAic/edit",
  },
  // { type: "super_tracks", label: "Super Tracks" },
];

const Intern = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState([]);

  useEffect(() => {
    async function getMatchTaskReport() {
      try {
        const res = await internApi.getMatchTaskReport();
        const newStats = taskList.map(({ type, ...rest }) => {
          return {
            type: type,
            correct: res["correct_" + type],
            incorrect: res["incorrect_" + type],
            ...rest,
          };
        });
        setStats(newStats);
      } catch (err) {
        console.log(err);
        if (err.response?.status === 404) {
          // toast.warn("There is no available data.");
        } else {
          toast.error("Something went wrong.");
        }
      }
    }
    getMatchTaskReport();
  }, []);

  return (
    <Container className="py-3" fluid>
      <Row className="justify-content-center py-2">
        <Col xs={12} md={8}>
          {stats?.length ? (
            <>
              {stats.map((stat) => {
                return (
                  <div className="d-flex justify-content-between p-3 mb-2 shadow-sm rounded tw-bg-white">
                    <Button
                      variant="secondary"
                      href={stat.instruction}
                      target="_blank"
                    >
                      Instruction
                    </Button>{" "}
                    <Button
                      variant="secondary"
                      onClick={() => navigate(`/panel/intern/${stat.route}`)}
                    >
                      {stat.label}
                    </Button>{" "}
                    <span className="d-flex align-items-center mx-1">
                      Total {stat.correct + stat.incorrect}
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Correct {stat.correct}
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Wrong {stat.incorrect}
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Skill{" "}
                      {stat.correct + stat.incorrect === 0
                        ? 0
                        : (
                            (stat.correct / (stat.correct + stat.incorrect)) *
                            100
                          )
                            .toFixed(2)
                            .replace(/[.,]00$/, "")}
                    </span>
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {taskList.map((stat) => {
                return (
                  <div className="d-flex justify-content-between p-3 mb-2 shadow-sm rounded">
                    <Button
                      variant="secondary"
                      href={stat.instruction}
                      target="_blank"
                    >
                      Instruction
                    </Button>{" "}
                    <Button
                      variant="secondary"
                      onClick={() => navigate(`/panel/intern/${stat.route}`)}
                    >
                      {stat.label}
                    </Button>{" "}
                    <span className="d-flex align-items-center mx-1">
                      Total 0
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Correct 0
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Wrong 0
                    </span>
                    <span className="d-flex align-items-center mx-1">
                      Skill 0
                    </span>
                  </div>
                );
              })}
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Intern;
